import { MatStepper } from '@angular/material/stepper';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { UtilsService } from 'src/app/services/utils.service';
import { partnerWallet } from './partner-wallet-banner.model';
import { PartnerWallet } from './partner-wallet-banner.model';
import { MobileBreakPointsService } from 'src/app/services/mobileBreakPoints.service';

@Component({
  selector: 'app-partner-wallet-banner',
  templateUrl: './partner-wallet-banner.component.html',
  styleUrls: ['./partner-wallet-banner.component.scss'],
})
export class PartnerWalletBannerComponent {
  partnerWallet: PartnerWallet[] = partnerWallet;
  @Input() walletProvider: string;
  @Input() showBackIcon: boolean;
  @Input() stepper: MatStepper | null;
  @Output() public back: EventEmitter<void> = new EventEmitter<void>();
  isMobile$: Observable<boolean>;
  constructor(
    public utilService: UtilsService,
    private mobileBreakPointService: MobileBreakPointsService
  ) {
    this.isMobile$ = this.mobileBreakPointService.mobileBreakPoints$;
  }

  getWalletDetails(walletProvider: string): PartnerWallet | undefined {
    const walletDetails = this.partnerWallet.find(
      (partner) =>
        partner.walletName.toLowerCase() === walletProvider.toLowerCase()
    );

    return walletDetails;
  }

  onBack() {
    this.back.emit();
  }
}
